import {
  Flex,
  IconButton,
  Skeleton,
  Text,
} from '@chakra-ui/react';
import InsightPicto from '@/insight/components/insightPicto';
import { insightTypeDictionnary } from '@/insight/lib/insightTypeDictionnary';
import { useEffect, useState } from 'react';
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from 'react-icons/md';
import { useLocation } from 'react-router-dom';
import SlidingInsights from './SlidingInsights';
export default function InsightCardList({ lists, onSetAsOutdated }) {
  const [data, setData] = useState();
  const [refreshCounter, setRefreshCounter] = useState(1);
  const location = useLocation();
  const setDisplay = (type, value) => {
    localStorage.setItem(type + location.pathname, value);
    setRefreshCounter(refreshCounter + 1);
  };
  const getDisplay = (type) => {
    return localStorage.getItem(type + location.pathname) !== 'false';
  };
  useEffect(() => {
    if (lists) {
      const newData = Object.entries(insightTypeDictionnary).map(([key, type]) => {
        const list = lists[type];
        if (list && list.length > 0) {
          return {
            type,
            list,
            title: {
              negative: 'Negative Feedback',
              improvement: 'Improvement Feedback',
              positive: 'Positive Feedback',
              behavior: 'Behaviors',
              motivation: 'Motivations'
            }[key]
          };
        }
        return null;
      }).filter(Boolean);
      setData(newData);
    }
  }, [lists]);
  return !data ? (
    <Flex pb={3} w="100%">
      <Skeleton height="50px" w="100%" />
    </Flex>
  ) : (
    <Flex flexDirection="column" width="100%" >
      {data.map((d, i) => (
        <Flex flexDirection="column" w="100%" key={i} gap={2} role="group" >
          <Flex alignItems="center" gap={1} px={3}>
            <InsightPicto size={20} type={d.type} />
            <Text>{d.title}</Text>
            <IconButton
              variant="greyTransparent"
              color="text.medium.grey"
              fontSize="16px"
              style={{ opacity: '0' }}
              _groupHover={{ opacity: '1 !important' }}
              icon={getDisplay(d.type) ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}
              onClick={() => setDisplay(d.type, !getDisplay(d.type))}
            />
          </Flex>
          {getDisplay(d.type) && (
            <SlidingInsights
              list={d.list}
              onSetAsOutdated={onSetAsOutdated}
            />
          )}
          {!getDisplay(d.type) && (
            <Flex pb={3}></Flex>
          )}
        </Flex>
      ))}
    </Flex>
  );
}
